<template>
  <div>
    <!--TOOLBAR-->
    <v-app-bar flat class="redColor text-white">
      <v-app-bar-title>{{
        $t("leko_employees.test_its.label")
      }}</v-app-bar-title>
      <v-divider class="mx-5 hidden-md-and-down" inset vertical />
    </v-app-bar>

    <v-row class="d-flex flex-column">
      <v-col xs="12" md="12" lg="12">
        <v-card flat>
          <v-row>
            <v-col xs="12" md="12" lg="12">
              <v-alert
                :model-value="alert.value"
                :type="alert.type"
                variant="tonal"
                border="bottom"
              >
                {{ alert.message }}
              </v-alert>
            </v-col>
            <v-col xs="12" lg="6">
              <v-form ref="form">
                <v-container grid-list-md>
                  <!-- PART CODE -->
                  <v-toolbar flat theme="dark">
                    <h2>
                      {{ $t("leko_employees.test_its.part_code") }}
                    </h2>
                  </v-toolbar>
                  <v-row mb-2 wrap align-center justify-center>
                    <v-col xs="10">
                      <v-text-field
                        v-model="partCode"
                        :label="$t('leko_employees.test_its.manufacturer_code')"
                        color="red-darken-1"
                      />
                    </v-col>
                    <v-col xs="12" md="12" lg="12">
                      <v-row class="align-center justify-center mb-3">
                        <v-btn
                          :loading="loading1"
                          color="red-darken-1"
                          class="mx-1"
                          @click="searchPart"
                        >
                          {{ $t("leko_employees.test_its.search") }}
                        </v-btn>
                        <v-btn
                          :loading="loading3"
                          :disabled="!result"
                          color="blue darken-1"
                          class="mx-1"
                          @click="updateCode"
                        >
                          {{ $t("leko_employees.test_its.update") }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>

                  <!-- LICENSE PLATE -->
                  <v-toolbar flat theme="dark">
                    <h2>
                      {{ $t("leko_employees.test_its.license_plate") }}
                    </h2>
                  </v-toolbar>
                  <v-row class="mb-2 wrap align-center justify-center">
                    <v-col xs="10">
                      <v-text-field
                        v-model="licensePlate"
                        :label="$t('leko_employees.test_its.license_plate')"
                        color="red-darken-1"
                      />
                    </v-col>
                    <v-col xs="12" md="12" lg="12">
                      <v-row class="align-center justify-center">
                        <v-btn
                          :loading="loading2"
                          color="red-darken-1"
                          class="mx-1"
                          @click="searchPlate"
                        >
                          {{ $t("leko_employees.test_its.search") }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-col>
            <v-col xs="12" lg="6">
              <v-row class="ma-4 d-flex flex-column align-start justify-center">
                <v-treeview
                  :items="result"
                  item-title="name"
                  item-value="_id"
                  activatable
                ></v-treeview>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col xs="12" md="12" lg="12">
        <v-card flat>
          <v-row row wrap>
            <v-col xs="12" />
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import getRequest from "../api/getRequest";
import postRequest from "../api/postRequest";

export default {
  data: () => ({
    loading1: false,
    loading2: false,
    loading3: false,
    alert: {
      value: false,
      type: "error",
      message: String,
    },
    partCode: null,
    licensePlate: null,
    result: [],
    showDropdown: false,
    hovered: -1,
    logs: [],
    logsCount: null,
    lastFivePlates: [],
  }),
  created() {},
  methods: {
    searchPart() {
      this.loading1 = true;
      getRequest("/info-car/search/", `code=${this.partCode}&populated=true`)
        .then((response) => {
          this.result = response;
          if (response && response.length > 0) {
            this.result = response.map((item) => ({
              id: item._id,
              name: item.description.descriptionId.title.it || "No title",
              children: item.applicability?.map((app) => ({
                id: app._id,
                name: `${app.brand} ${app.model}`,
                children: app.versions?.map((v) => ({
                  id: v._id,
                  name: v.version,
                })),
              })),
            }));
          }
        })
        .catch((error) => {
          this.result = null;
          this.showAlert("error", error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    updateCode() {
      this.loading3 = true;
      getRequest("/info-car/update/", `code=${this.partCode}`)
        .then((response) => {
          this.showAlert("success", response);
        })
        .catch((error) => {
          this.showAlert("error", error);
        })
        .finally(() => {
          this.loading3 = false;
        });
    },
    searchPlate() {
      this.loading2 = true;
      getRequest(`/info-car/plate/${this.licensePlate}`, "")
        .then((response) => {
          this.result = response;
          if (response && response.length > 0) {
            this.result = response.map((item) => ({
              id: item._id,
              name: item.brand.title || "No title",
              children: {
                id: item.version._id,
                name: `${item.version.fullDescription}`,
              },
            }));
            let data = {
              user: this.$store.getters.userEmail,
              plate: this.licensePlate.toUpperCase(),
            };
            postRequest
              .object(`/plate-logs`, data)
              .then(() => {
                // console.log('res',res)
              })
              .catch(() => {});
          }
        })
        .catch((error) => {
          this.showAlert("error", error);
        })
        .finally(() => {
          this.loading2 = false;
        });
    },

    showAlert(type, message) {
      this.alert.type = type;
      this.alert.message = message;
      this.alert.value = true;
      setTimeout(() => {
        this.alert.value = false;
      }, 2000);
    },
  },
};
</script>

<!--

this.loading1 = false;
-->
